import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CrawfordDialogComponent, DialogButton, CrawfordSnackbarService } from 'crawford-shell';
import { ExportTemplate } from '../../model/export-template.model';
import { ExportService } from '../service/export.service';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-claim-export-dialog',
  templateUrl: './claim-export-dialog.component.html',
  styleUrls: ['./claim-export-dialog.component.scss']
})
export class ClaimExportDialogComponent implements OnInit {
  public templateSaved: Subject<string> = new Subject<string>();

  public actionText = 'Save';
  public nameAlreadyExists: boolean;
  public isProtectedName: boolean;
  public saveTemplateForm: FormGroup;

  private existingTemplates: ExportTemplate[];
  private selectedColumns: string[];

  @ViewChild('saveTemplateDialog') private dialog: CrawfordDialogComponent;

  public dialogButtons = [
    new DialogButton(this.saveTemplate.bind(this), { content: 'Save', isPrimary: true }),
    new DialogButton(this.cancelSaveTemplate.bind(this), { content: 'Cancel', isPrimary: false })
  ];

  constructor(
    private formBuilder: FormBuilder,
    private exportService: ExportService,
    private snackbarService: CrawfordSnackbarService
  ) {
  }

  public ngOnInit(): void {
    this.createSaveTemplateForm();
  }

  public openDialog(selectedColumns: string[], existingTemplates: ExportTemplate[], selectedTemplate: ExportTemplate): void {
    this.selectedColumns = selectedColumns;
    this.existingTemplates = existingTemplates;

    const name = selectedTemplate ? selectedTemplate.name : '';
    this.nameAlreadyExists = selectedTemplate ? true : false;
    this.isProtectedName = selectedTemplate ? selectedTemplate.isProtected : false;
    this.actionText = 'Save';

    this.saveTemplateForm.setValue({
      name: name
    });

    this.dialog.showDialog();
  }

  private createSaveTemplateForm(): void {
    this.saveTemplateForm = this.formBuilder.group({
      name: new FormControl('', [ Validators.required ])
    });

    this.saveTemplateForm.controls.name.valueChanges.subscribe(
      value => this.nameChanged(value)
    );
  }

  private nameChanged(value: string): void {
    if (!value || !this.existingTemplates) {
      return;
    }

    this.nameAlreadyExists = false;
    this.isProtectedName = false;

    this.existingTemplates.forEach(x => {
      if (x.name.toLowerCase() !== value.toLowerCase()) {
        return;
      }

      this.nameAlreadyExists = true;
      this.isProtectedName = x.isProtected;
    });

    this.actionText = this.nameAlreadyExists ? 'Overwrite' : 'Save';
  }

  public saveTemplate(): void {
    if (this.saveTemplateForm.invalid || this.isProtectedName) {
      return;
    }

    const name = this.saveTemplateForm.value.name;

    if (!name) {
      throw new Error('The template to be saved needs a name');
    }

    this.exportService.saveTemplate(name, this.selectedColumns).subscribe(
      result => {
        this.successfulSaveCallback(name);
      }
    );
  }

  public cancelSaveTemplate(): void {
    this.dialog.hideDialog();
  }

  private successfulSaveCallback(name: string): void {
    this.dialog.hideDialog();
    this.templateSaved.next(name);
    this.snackbarService.displaySuccessMessage('Template Saved');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-export/dialog/claim-export-dialog.component.ts